import { withErrorBoundary } from "@sentry/nextjs";
import { gql } from "graphql-request";
import { FC } from "react";
import styled from "styled-components";
import { LegacyImage, Markdown, ArrowLink } from "components";
import { Carousel4CardContent } from "types/graphql/generated";

interface Props {
  className?: string;
  content: Carousel4CardContent;
}

const Card: FC<Props> = withErrorBoundary(
  ({ content: { carousel4Link, linkLabel, title, description, carousel4Image }, className = "" }) => {
    return (
      <StyledCard className={className}>
        {carousel4Image?.data?.image.src !== undefined ? (
          <LegacyImage
            src={carousel4Image?.data?.image.src}
            alt={carousel4Image?.data?.image.alt}
            layout="fill"
            objectFit="cover"
            className="Carousel4__image"
          />
        ) : null}

        <h2 className="Font_24_32_600">{title}</h2>
        <Markdown className="Carousel4__carouselDescription Color_secondary">{description}</Markdown>
        {carousel4Link && linkLabel && (
          <ArrowLink href={carousel4Link} className="Carousel4__carouselLink Font_18_26_600">
            {linkLabel}
          </ArrowLink>
        )}
      </StyledCard>
    );
  },
  {}
);

const StyledCard = styled.div`
  .Carousel4__image {
    position: relative;
    max-width: 356px;
    width: 100%;
    height: 268px;
    margin-bottom: 40px;
  }

  .Carousel4__carouselDescription {
    margin-top: 24px;
  }

  .Carousel4__carouselLink {
    margin-top: 12px;
  }

  @media (max-width: ${({ theme }) => `${theme.breakpoints.lg}px`}) {
    .Carousel4__image {
      max-width: unset;
    }
  }

  @media (max-width: ${({ theme }) => `${theme.breakpoints.md}px`}) {
    .Carousel4__image {
      min-width: 320px;
    }
  }
`;

gql`
  fragment Carousel4CardContent on ComponentNestedCarousel4Teams {
    id
    title
    description
    linkLabel
    carousel4Link

    carousel4Image {
      data {
        image: attributes {
          src: hash
          alt: alternativeText
        }
      }
    }
  }
`;

export { Card };
